import React, { Component } from 'react'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import FooterColumns from './FooterColumns'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import PropTypes from 'prop-types'

@inject('categories')
@observer
class Footer extends Component {
  componentWillMount () {
    this.props.categories.get()
  }

  render () {
    let {
      type,
      categories
    } = this.props

    if (!categories.loaded) {
      return (<div />)
    }

    return (
      <footer className={'b-footer b-footer_' + this.props.type}>
        <div className='b-footer-inner'>
          <div className='b-footer-columns'>
            <div className='b-footer-column'>
              <NavLink to='/' className='b-footer-logo' />

              {/*
              <div className='b-footer-selects'>
                <div className='b-form-item-select'>
                  <select>
                    <option value='eur'>Euro</option>
                  </select>
                </div>

                <div className='b-form-item-select'>
                  <select>
                    <option value='en'>English</option>
                  </select>
                </div>
              </div>
              */}

            </div>

            <FooterColumns categories={categories.data} />
          </div>

          <div className='b-icons'>
            <a href='#' className='b-icon b-icon_fb' />
            <a href='#' className='b-icon b-icon_twitter' />
            <a href='#' className='b-icon b-icon_envelope' />
          </div>
        </div>
      </footer>
    )
  }
}

Footer.defaultProps = {
  type: 'normal'
}

Footer.propTypes = {
  type: PropTypes.string,
  categories: MobxPropTypes.observableObject
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js